import { PoolConfig, QuoteToken, PoolCategory } from './types'

const pools: PoolConfig[] = [

 {
   sousId: 2,
    tokenName: 'WFTM',
    stakingTokenName: QuoteToken.XPAST,
    stakingTokenAddress: '0xD3111Fb8BDf936B11fFC9eba3b597BeA21e72724',
    contractAddress: {
      250: '0x497aD88D600206adCfd545b5c3e4BE0127Cf0Fd5'
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://docs.xmas-past.com/',
    harvest: true,
    tokenPerBlock: '0.0000924929',
    sortOrder: 1,
    isFinished: true, 
    tokenDecimals: 18,
    burnFee: 0
   }
  // {
  //   sousId: 1,
  //   tokenName: 'TWT',
  //   stakingTokenName: QuoteToken.SYRUP,
  //   stakingTokenAddress: '0x009cF7bC57584b7998236eff51b98A168DceA9B0',
  //   contractAddress: {
  //     97: '0xAfd61Dc94f11A70Ae110dC0E0F2061Af5633061A',
  //     56: '0xAfd61Dc94f11A70Ae110dC0E0F2061Af5633061A',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   projectLink: 'https://trustwallet.com/',
  //   harvest: true,
  //   tokenPerBlock: '20',
  //   sortOrder: 999,
  //   isFinished: true,
  //   tokenDecimals: 18,
  // },
]

export default pools
